var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgIconMembership(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.992,
    height: 34.427,
    viewBox: "0 0 32.992 34.427",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10.666)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.1 12.91)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M61.406,192H32.717a.718.718,0,0,0-.717.717V212.8a.717.717,0,0,0,.717.717H61.406a.718.718,0,0,0,.717-.717V192.717A.718.718,0,0,0,61.406,192Zm-.717,20.082H33.434V193.434H60.689v18.648Z",
    transform: "translate(-32 -192)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.666 7.172)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M42.941,106.667H11.383a.718.718,0,0,0-.717.717v5.738a.718.718,0,0,0,.717.717H42.941a.718.718,0,0,0,.717-.717v-5.738A.717.717,0,0,0,42.941,106.667Zm-.717,5.738H12.1v-4.3H42.224Z",
    transform: "translate(-10.666 -106.667)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.445 7.172)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M246.05,106.667a.718.718,0,0,0-.717.717V133.2a.717.717,0,1,0,1.434,0v-25.82A.717.717,0,0,0,246.05,106.667Z",
    transform: "translate(-245.333 -106.667)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.404)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M107.491,7.72c-.737-3.458-5.135-7.169-8.066-7.666A2.869,2.869,0,0,0,96,2.869a2.88,2.88,0,0,0,.65,1.819.085.085,0,0,1,.014.017c2.13,2.721,9.221,3.764,10.027,3.874a.762.762,0,0,0,.1.007.718.718,0,0,0,.7-.866ZM97.774,3.794a.485.485,0,0,0-.042-.05,1.413,1.413,0,0,1-.3-.875,1.436,1.436,0,0,1,1.434-1.434,1.627,1.627,0,0,1,.3.03c2.15.364,5.4,2.966,6.563,5.505C103.232,6.51,99.017,5.435,97.774,3.794Z",
    transform: "translate(-96)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.415)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M253.523,0a2.827,2.827,0,0,0-.536.05c-2.949.5-7.347,4.211-8.085,7.67a.718.718,0,0,0,.7.866c.032,0,.065,0,.1-.006.806-.11,7.9-1.153,10.027-3.874.006-.006.01-.013.016-.019A2.869,2.869,0,0,0,253.523,0Zm1.136,3.745a.481.481,0,0,0-.042.05c-1.241,1.638-5.457,2.715-7.955,3.176,1.168-2.542,4.415-5.142,6.583-5.51a1.489,1.489,0,0,1,.278-.027,1.435,1.435,0,0,1,1.136,2.311Z",
    transform: "translate(-244.886)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMembership);
export default __webpack_public_path__ + "static/media/icon-membership.248dbc68b911fcb4cc597d7184f22d0a.svg";
export { ForwardRef as ReactComponent };